import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasOvw202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_ovw_202606",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 390,
  clicks: 7,
  adsSpendDollars: 25,
  budgetDollars: 600,
  salesDollars: 0,
  bestEstimateRoas: 0,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.04,
  newCustomersAcquired: 0,
  reorderConversions: 0,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
